import { render, staticRenderFns } from "./OptometristYuFuKuan.vue?vue&type=template&id=e6423962&scoped=true&"
import script from "./OptometristYuFuKuan.vue?vue&type=script&lang=js&"
export * from "./OptometristYuFuKuan.vue?vue&type=script&lang=js&"
import style0 from "./OptometristYuFuKuan.vue?vue&type=style&index=0&id=e6423962&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e6423962",
  null
  
)

export default component.exports